import { Col, Row } from 'react-bootstrap';
import { OvertimeWorkedAndScheduledPerPeriodModel } from '../../models/OvertimeSchedule';
import {
  formatHours,
  getAverageWorkedOvertimePerEmployee,
  getCompliancePercent,
  getComplianceVariant,
} from '../../utils/kpiMetrics.utils';
import { getTotalScheduledOvertimeForWeek, getTotalWorkedOvertimeForWeek } from '../../utils/overtimeTotals.utils';
import { KpiCard } from './KpiCard';

interface KpisContainerProps {
  data: OvertimeWorkedAndScheduledPerPeriodModel[];
  selectedPeriodIndex: number;
}

export const KpisContainer = ({ data, selectedPeriodIndex }: KpisContainerProps) => {
  const averageOvertimePerEmployee = getAverageWorkedOvertimePerEmployee(data, selectedPeriodIndex);
  const compliance = getCompliancePercent(data, selectedPeriodIndex);
  const totalScheduled = getTotalScheduledOvertimeForWeek(data, selectedPeriodIndex);
  const totalWorked = getTotalWorkedOvertimeForWeek(data, selectedPeriodIndex);
  const totalPeriodBase = data[0].hoursForLiquidationBase;
  const dailyBase = data[0].numberOfDailyBaseHours;
  const periodOvertimeLimit = data[0].totalPerPeriodOvertimeHoursAllowed;
  const dailyOvertimeLimit = data[0].totalDailyOvertimeHoursAllowed;

  return (
    <Row className="g-2 mb-3">
      <Col xl={3} lg={3} md={6} sm={12}>
        <KpiCard
          rows={[
            {
              icon: 'mdi mdi-account-clock',
              label: 'Promedio ejecutadas por empleado',
              value: formatHours(averageOvertimePerEmployee),
              variant: 'primary',
            },
            {
              icon: 'mdi mdi-percent',
              label: 'Cumplimiento periodo',
              value: `${compliance.toFixed(2)}%`,
              variant: getComplianceVariant(compliance),
            },
          ]}
        />
      </Col>
      <Col xl={3} lg={3} md={6} sm={12}>
        <KpiCard
          rows={[
            {
              icon: 'mdi mdi-calendar-clock-outline',
              label: 'Total HE proyectadas',
              value: formatHours(totalScheduled),
              variant: 'success',
            },
            {
              icon: 'mdi mdi-clock-outline',
              label: 'Total HE ejecutadas',
              value: formatHours(totalWorked),
              variant: 'warning',
            },
          ]}
        />
      </Col>
      <Col xl={3} lg={3} md={6} sm={12}>
        <KpiCard
          rows={[
            {
              icon: 'mdi mdi-calendar-range',
              label: 'Base del periodo',
              value: formatHours(totalPeriodBase),
              variant: 'primary',
            },
            {
              icon: 'mdi mdi-calendar-today',
              label: 'Base del día',
              value: formatHours(dailyBase),
              variant: 'primary',
            },
          ]}
        />
      </Col>
      <Col xl={3} lg={3} md={6} sm={12}>
        <KpiCard
          rows={[
            {
              icon: 'mdi mdi-timer-sand',
              label: 'Límite HE periodo',
              value: formatHours(periodOvertimeLimit),
              variant: 'danger',
            },
            {
              icon: 'mdi mdi-timer-outline',
              label: 'Límite HE día',
              value: formatHours(dailyOvertimeLimit),
              variant: 'danger',
            },
          ]}
        />
      </Col>
    </Row>
  );
};
